export default __webpack_public_path__ + "static/media/avataaars__1___1_-removebg-preview.8c4c5e01.png";